export const StatCard = ({ label, value, icon: Icon, accent = false, testId }) => (
  <div
    data-testid={testId}
    className={`rounded-xl border border-[#E5E7EB] bg-white p-4 shadow-sm transition-shadow duration-200 hover:shadow-md sm:p-5 ${accent ? "border-t-4 border-t-[#FEB601]" : ""}`}
  >
    <div className="flex items-start justify-between gap-3">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</p>
      {Icon && <Icon className="h-5 w-5 shrink-0 text-[#000B45]/60" />}
    </div>
    <p data-testid={testId ? `${testId}-value` : undefined} className="mt-3 font-mono text-2xl font-semibold text-[#000B45] sm:text-3xl">
      {value}
    </p>
  </div>
);
